export const translationConfig = {
  common: ['CommonUI.Features', 'Common.GameSorts'],
  feature: 'Feature.GamePage'
};

export default translationConfig;
